import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
var LoadableDeviationDuperbrowseContext = function (_a) {
    var children = _a.children, streamId = _a.streamId, parent = _a.parent, isLoadMoreAllowed = _a.isLoadMoreAllowed, streamItemSelector = _a.streamItemSelector;
    return (React.createElement(DuperbrowseStreamContextProvider, { stream: {
            streamId: streamId,
            parent: parent,
            enableLoader: isLoadMoreAllowed,
            streamItemSelector: streamItemSelector,
            itemSchema: 'deviation',
        } }, children));
};
LoadableDeviationDuperbrowseContext.displayName =
    'LoadableDeviationDuperbrowseContext';
export default LoadableDeviationDuperbrowseContext;
//# sourceMappingURL=LoadableDeviationDuperbrowseContext.js.map